import React from "react";
import "./Footer.css";
import { FaInstagram, FaYoutube, FaFacebook } from "react-icons/fa";
//import WhatsAppButton from "../WhatsAppButton";

const Footer = () => {
  // get current malaysia year
  const getCurrentYear = () => {
    const malaysiaTime = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kuala_Lumpur",
    });
    return new Date(malaysiaTime).getFullYear();
  };

  const handleNavigation = (type) => {
    window.location.href = `/bodyfriend-products?type=${encodeURIComponent(
      type
    )}`;
  };

  const navigateToPage = (path) => {
    window.location.href = path;
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-section">
          <h4>Category</h4>
          <ul>
            <li onClick={() => handleNavigation("Healthcare Robot")}>
              Healthcare Robot
            </li>
            <li onClick={() => handleNavigation("Massage sofa")}>
              Massage Sofa
            </li>
            <li onClick={() => handleNavigation("Massage Chair")}>
              Massage Chair
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Information</h4>
          <ul>
            {/* <li onClick={() => navigateToPage("/events")}>Event</li> */}
            <li onClick={() => navigateToPage("/about-us")}>About Us</li>
            <li onClick={() => navigateToPage("/FAQ")}>FAQ</li>
            <li onClick={() => navigateToPage("/contact-us")}>Contact Us</li>
            <li onClick={() => navigateToPage("/product-trial")}>
              Product Trial
            </li>
            <li onClick={() => navigateToPage("/store")}>Our Store</li>
            <li
              onClick={() =>
                navigateToPage("/public_html/warranty/warranty.php")
              }
            >
              Warranty
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Know More</h4>
          <ul>
            <li onClick={() => navigateToPage("/terms-of-use")}>
              Terms of Use
            </li>
            <li onClick={() => navigateToPage("/privacy-policy")}>
              Privacy Policy
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="social-icons">
          <a
            href="https://www.facebook.com/profile.php?id=61572342897636"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.youtube.com/@BodyfriendMalaysia"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
        </div>

        <div className="footer-info">
          <p>
            No 22, Jalan Anggerik Mokara 31/47, Kota Kemuning, 40460 Shah Alam,
            Selangor.
          </p>
          <p>
            &copy; {getCurrentYear()}. BODYFRIEND MALAYSIA. All Rights Reserved.
          </p>
        </div>
      </div>

{/* WhatsApp Floating Button - Temporarily Disabled
<WhatsAppButton />
*/}
    </footer>
  );
};

export default Footer;